export default "__VITE_ASSET__CswRMn_4__"